import { createStore, withProps, select } from '@ngneat/elf';
import { Observable } from 'rxjs';
import { BusyService } from '../services/busy.service';

export interface IBaseState {
  loading: boolean;
}

export abstract class BaseRepository<T extends IBaseState> {
  protected store;
  // loading$: Observable<boolean>;
  name: string;

  // busyService?: BusyService
  constructor(name: string, initialState: T) {
    this.store = createStore({ name }, withProps<T>(initialState));
    // this.loading$ = this.store.pipe(select((state) => state.loading));
    this.name = name;

    // if (busyService) {
    //   this.loading$.subscribe((loading) => {
    //     // console.log('----', `${name}-spinner`);
    //     busyService.setBusy(loading, `${name}-spinner`); // Добавляем уникальный суффикс
    //   });
    // }
  }

  // setLoading(loading: boolean): void {
  //   this.store.update((state) => ({ ...state, loading }));
  // }

  destroy(): void {
    this.store.complete();
    this.store.destroy();
  }
}
